// import { ApplicationConfig, provideBrowserGlobalErrorListeners, provideZoneChangeDetection } from '@angular/core';
// import { provideRouter } from '@angular/router';
//
// import { routes } from './app.routes';
// import { provideClientHydration, withEventReplay } from '@angular/platform-browser';
// import {
//   HTTP_INTERCEPTORS,
//   provideHttpClient,
//   withFetch,
//   withInterceptors,
//   withInterceptorsFromDi
// } from '@angular/common/http';
// import {AuthInterceptor} from '../core/interceptors/auth-interceptor';
//
// export const appConfig: ApplicationConfig = {
//   providers: [
//     provideBrowserGlobalErrorListeners(),
//     provideZoneChangeDetection({ eventCoalescing: true }),
//     provideHttpClient(
//       withFetch(),
//       withInterceptorsFromDi()
//     ),
//     { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
//     // provideRouter(routes),
//     provideClientHydration(withEventReplay())
//   ]
// };
//

import {
  ApplicationConfig,
  provideBrowserGlobalErrorListeners,
  provideZoneChangeDetection,
} from '@angular/core';
import { provideRouter, withComponentInputBinding } from '@angular/router';

import { routes } from './app.routes';
import {
  provideClientHydration,
  withEventReplay,
  withHttpTransferCacheOptions,
} from '@angular/platform-browser';
import {
  HTTP_INTERCEPTORS,
  provideHttpClient,
  withFetch,
  withInterceptorsFromDi,
} from '@angular/common/http';
import { AuthInterceptor } from '../core/interceptors/auth-interceptor';
import { HttpClinicContextInterceptor } from '../core/interceptors/http-clinic-context.interceptor';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideHttpClient(withFetch(), withInterceptorsFromDi()),
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: HttpClinicContextInterceptor, multi: true },
    provideRouter(routes, withComponentInputBinding()), // ✅ put router here
    provideClientHydration(
      withEventReplay(),
      // Exclude clinic-context endpoints so SSR never serves a stale no-header response
      withHttpTransferCacheOptions({
        filter: (req) =>
          !req.url.includes('clinic-status') && !req.url.includes('clinic-memberships'),
      }),
    ),
  ],
};
